<template>
    <CompassModal
        id="popupAgenda"
        v-model:visible="showModal"
        size="large"
        class="calendar-view"
        @closed="$emit('close')"
    >
        <template #header>
            <div class="dialog__header">
                <CompassIconButton icon="close" @click="$emit('close')" />
            </div>
        </template>
        <template #default>
            <div class="dialog__default">
                <div id="content_agenda" class="mt-2">
                    <div id="third-fullcalendar">
                        <div
                            id="calendar"
                            class="well"
                            :relatedtype="relatedType"
                            :relatedid="'' + relatedId + ''"
                        ></div>
                    </div>
                </div>
            </div>
        </template>
    </CompassModal>
</template>

<script>
export default {
    props: {
        relatedType: {
            type: String,
            required: true,
            default: '',
        },
        relatedId: {
            type: [Number, Boolean],
            required: true,
            default: false,
        },
        nameCallbackFunction: {
            type: String,
            required: true,
            default: '',
        },
        prefixXsl: {
            type: String,
            required: true,
            default: '',
        },
    },
    data() {
        return {
            showModal: true,
        };
    },
    mounted() {
        AgendaTab.loadAgendaTab(
            this.relatedType,
            this.relatedId,
            this.nameCallbackFunction,
            this.prefixXsl,
            'agenda',
        );
    },
};
</script>

<style lang="scss" scoped>
.calendar-view {
    .dialog {
        &__header {
            display: flex;
            justify-content: flex-end;
            padding: 24px 32px;
        }
    }
}
</style>
